import type { IconSvgObject } from './types';

const ExpandParagraphIcon: IconSvgObject = [
  ["path", { d: "M8 6.99998C8 6.99998 5.79053 4.00001 4.99998 4C4.20942 3.99999 2 7 2 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 12H22M12 8H22M12 16H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 17C2 17 4.20947 20 5.00002 20C5.79058 20 8 17 8 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 5V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ExpandParagraphIcon;
